import React from "react";

// Tiny inline markup:
//   *text*  → terracotta highlight
//   _text_  → italic + softer color
// Newlines become <br/>.
export function renderRichInline(text) {
  if (!text) return null;
  const tokens = String(text).split(/(\*[^*\n]+\*|_[^_\n]+_)/g);
  return tokens.map((tok, idx) => {
    if (!tok) return null;
    if (tok.startsWith("*") && tok.endsWith("*") && tok.length > 2) {
      return (
        <span key={idx} className="text-terracotta">
          {tok.slice(1, -1)}
        </span>
      );
    }
    if (tok.startsWith("_") && tok.endsWith("_") && tok.length > 2) {
      return (
        <em key={idx} className="italic text-ink-soft not-italic-children">
          {tok.slice(1, -1)}
        </em>
      );
    }
    return <React.Fragment key={idx}>{tok}</React.Fragment>;
  });
}

export function RichMultiline({ text, className = "" }) {
  const lines = (text || "").split("\n");
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {renderRichInline(line)}
          {i < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </span>
  );
}
